export default "__VITE_ASSET__BSM7VD1B__"